import { render, staticRenderFns } from "./FairPayMenu.vue?vue&type=template&id=5331edb6&scoped=true"
import script from "./FairPayMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FairPayMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FairPayMenu.vue?vue&type=style&index=0&id=5331edb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331edb6",
  null
  
)

export default component.exports